import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { SOFTWARE_ROLES, filterItemsByAccess, getCurrentAppUser, normalizeSoftwareRole } from '../utils/accessControl';
import './Sidebar.css';

function Sidebar({ onLogout }) {
  const { t } = useTranslation();
  const [isHidden, setIsHidden] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = getCurrentAppUser();
  const softwareRole = normalizeSoftwareRole(currentUser?.softwareRole);
  const menuItems = [
    { id: 'home', icon: '\u{1F3E0}', label: t('menu.home'), path: '/' },
    { id: 'clients', icon: '\u{1F465}', label: t('menu.clients'), path: '/clients' },
    { id: 'vehicles', icon: '\u{1F697}', label: t('menu.vehicles'), path: '/vehicles' },
    { id: 'vendors', icon: '\u{1F91D}', label: t('menu.vendors'), path: '/vendors' },
    { id: 'inventory', icon: '\u{1F4E6}', label: t('menu.inventory'), path: '/inventory' },
    { id: 'hr', icon: '\u{1F4D6}', label: t('menu.hr'), path: '/hr' },
    { id: 'timeTracking', icon: '\u23F1\uFE0F', label: t('menu.timeTracking'), path: '/time-tracking' },
    { id: 'accounting', icon: '\u{1F4CA}', label: t('menu.accounting'), path: '/accounting' },
    { id: 'jobcards', icon: '\u{1F4CB}', label: t('menu.jobCards'), path: '/jobcards' },
    { id: 'bays', icon: '\u25A6', label: t('menu.bays'), path: '/bays' },
    { id: 'inspection', icon: '\u{1F50D}', label: t('menu.inspection'), path: '/inspection' },
    { id: 'invoices', icon: '\u{1F4C4}', label: t('menu.invoices'), path: '/invoices' },
    { id: 'estimates', icon: '\u{1F4C8}', label: t('menu.estimates'), path: '/estimates' },
    { id: 'appointments', icon: '\u{1F4C5}', label: t('menu.appointments'), path: '/appointments' },
    { id: 'serviceReminders', icon: '\u{1F514}', label: t('menu.serviceReminders'), path: '/service-reminders' },
  ];

  const bottomItems = softwareRole === SOFTWARE_ROLES.GUARD ? [] : [
    { id: 'shortcuts', icon: '\u2328\uFE0F', label: t('menu.shortcuts') },
    { id: 'settings', icon: '\u2699\uFE0F', label: t('menu.settings') },
  ];
  const visibleMenuItems = filterItemsByAccess(menuItems, 'path', currentUser);

  return (
    <>
      <button
        type="button"
        className={`sidebar-toggle ${isHidden ? 'sidebar-toggle-hidden' : ''}`}
        onClick={() => setIsHidden((current) => !current)}
        aria-label={isHidden ? t('menu.showSidebar') : t('menu.hideSidebar')}
        title={isHidden ? t('menu.showSidebar') : t('menu.hideSidebar')}
      >
        {isHidden ? '>' : '<'}
      </button>

      <div className={`sidebar ${isHidden ? 'sidebar-hidden' : ''}`}>
      <div className="sidebar-header">
        <div className="logo">VS</div>
      </div>

      <nav className="sidebar-nav">
        {visibleMenuItems.map((item) => (
          <NavLink
            key={item.id}
            to={item.path || '#'}
            end={item.path === '/'}
            onClick={(event) => {
              if (item.path === '/hr') {
                event.preventDefault();
                navigate('/hr', {
                  replace: location.pathname === '/hr',
                  state: { refreshAt: Date.now() },
                });
              }
            }}
            className={({ isActive }) => `nav-item${isActive && item.path ? ' active-item' : ''}`}
            title={item.label}
            style={{ pointerEvents: !item.path ? 'none' : 'auto', opacity: !item.path ? 0.6 : 1 }}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        {bottomItems.map((item) => (
          <div key={item.id} className="nav-item" title={item.label}>
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </div>
        ))}
        <div className="nav-item logout" onClick={onLogout} title={t('menu.logout')}>
          <span className="nav-icon">{'\u{1F6AA}'}</span>
          <span className="nav-label">{t('menu.logout')}</span>
        </div>
      </div>
      </div>
    </>
  );
}

export default Sidebar;
